module.exports = __webpack_public_path__ + "static/media/tomato-erily-mariel-unsplash.653314b1.jpg";